export default "__VITE_ASSET__CYkH7cON__"